export const PERMISSION_VIEW_CHANNELS = 56;

export function isChannelsModuleVisibleInPermissionList(permissionIds) {
  const list = permissionIds || [];
  return !list.some((p) => Number(p) === PERMISSION_VIEW_CHANNELS);
}
